const DraggableObject = (context) => {
  /*
   * Use _start and _end to set the status,
   * to prevent that update fires without dragging when data changes.
   */
  const _drag = {
    status: 'unset'
  }
  function _update (callback) {
    if (_drag.status === 'idle') {
      callback.call()
      _end()
    }
  }
  function _start () {
    _drag.status = 'idle'
  }
  function _end () {
    _drag.status = 'pause'
  }
  return {
    update: _update,
    start: _start,
    end: _end
  }
}

export {
  DraggableObject
}
